import { render, staticRenderFns } from "./CrmCloseEvent.vue?vue&type=template&id=7a7d638b"
import script from "./CrmCloseEvent.vue?vue&type=script&lang=ts"
export * from "./CrmCloseEvent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a7d638b')) {
      api.createRecord('7a7d638b', component.options)
    } else {
      api.reload('7a7d638b', component.options)
    }
    module.hot.accept("./CrmCloseEvent.vue?vue&type=template&id=7a7d638b", function () {
      api.rerender('7a7d638b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/crm/events/CrmCloseEvent.vue"
export default component.exports